(function () {
  const cache = window.bzQuickViewCache || new Map();
  window.bzQuickViewCache = cache;

  function getButtonUrl(button) {
    if (!button || !button.dataset.url || !button.dataset.template) return null;
    const productUrl = button.dataset.url.split('?')[0];
    const variant = button.dataset.variantid ? `&variant=${button.dataset.variantid}` : '';
    return `${productUrl}?view=${button.dataset.template}${variant}`;
  }

  function fetchModal(url) {
    if (!url) return Promise.resolve('');
    if (!cache.has(url)) {
      cache.set(
        url,
        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error(`Quick view request failed: ${response.status}`);
            return response.text();
          })
          .catch((error) => {
            cache.delete(url);
            throw error;
          })
      );
    }
    return cache.get(url);
  }

  function prefetchFromEvent(event) {
    const button = event.target.closest('bz-quick-view button[data-template][data-url]');
    const url = getButtonUrl(button);
    if (url) fetchModal(url).catch(() => {});
  }

  function setLoading(button, isLoading) {
    const spinner = button.querySelector('.loading__spinner');
    button.classList.toggle('loading', isLoading);
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
    if (isLoading) {
      button.setAttribute('disabled', 'true');
    } else {
      button.removeAttribute('disabled');
    }
  }

  function openModal(button, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = doc.querySelector('[data-html="content"]');
    const modalContainer = document.querySelector('.js-quick_view');
    if (!content || !modalContainer) return;

    document.body.classList.add('overflow-hidden', 'modal_view');
    modalContainer.innerHTML = content.innerHTML;

    const modalEl = modalContainer.querySelector('bz-modal');
    if (!modalEl) return;
    modalEl._openerButton = button;

    const modalContent = modalEl.querySelector('.quick-add-modal__content');
    if (!modalContent) return;

    window.setTimeout(() => modalContent.classList.add('wbmodl'), 30);
    if (typeof window.trapFocus === 'function') window.trapFocus(modalContent);
    modalContent.focus();
    if (window.ProductModel) window.ProductModel.loadShopifyXR();
  }

  document.addEventListener('pointerenter', prefetchFromEvent, true);
  document.addEventListener('focusin', prefetchFromEvent, true);
  document.addEventListener('touchstart', prefetchFromEvent, { capture: true, passive: true });

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest('bz-quick-view button[data-template][data-url]');
      if (!button) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      setLoading(button, true);
      fetchModal(getButtonUrl(button))
        .then((html) => openModal(button, html))
        .catch((error) => console.error('Quick view error:', error))
        .finally(() => setLoading(button, false));
    },
    true
  );
})();
